import { Alert } from '@mui/material'

interface GenericErrorProps {
  title?: string
}

const GenericError = ({ title = 'Something went wrong. Please try again.' }: GenericErrorProps) => {
  return <Alert severity="error">{title}</Alert>
}

export default GenericError
